import React, { useState, useContext, useEffect } from "react"
import blogFetch from "../../axios/config";
import Context from "../../context/Context";
import Button from "@mui/material/Button";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import toast from "react-hot-toast";
import {
  Pagination,
} from "@mui/material";
import language from "../../nls/language.json";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { DateTimeFmt } from "../../utils/DataUtils";
import { AddMensagemModal, EditMensagemModal } from "./modals";
import dayjs from "dayjs";
import './MessageSector.css';

const QTD_INITAL_HOUR = 24;

const INITIAL_ADD_MESSAGE = {
  mensagem_Texto: "",
  mensagem_DataInicio: dayjs(new Date()).$d,
  mensagem_DataFim: dayjs(new Date().getTime() + (QTD_INITAL_HOUR * 60 * 60 * 1000)).$d,
  isagA_Mensagem_Setores: []
};

const INITIAL_UPDATE_MESSAGE = {
  mensagem_Ativo: true,
  mensagem_Key: 0,
  mensagem_Texto: "",
  mensagem_DataInicio: "",
  mensagem_DataFim: "",
  isagA_Mensagem_Setores: []
};

export default function MessageSector() {
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);

  const [selectedAddMessage, setSelectedAddMessage] = useState(INITIAL_ADD_MESSAGE)
  const [selectedMessage, setSelectedMessage] = useState(INITIAL_UPDATE_MESSAGE)
  const [messageSector, SetMessageSector] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState();
  const [allSectors, setAllSectos] = useState([]);

  const {
    getStatusSideBar,
    selectedCountry,
    getSector
  } = useContext(Context);

  useEffect(() => {
    getMessageSector();
    getAllSectors()
  }, [currentPage])

  const getAllSectors = async () => {
    try {
      const response = await getSector();
      setAllSectos(response);
    } catch (error) {
      console.error(error);
    }
  }

  // const handlePageChange = (event, newPage) => {
  //   setCurrentPage(newPage);
  // };

  const getMessageSector = async () => {
    try {
      const skip = (currentPage - 1) * rowsPerPage;
      const take = rowsPerPage;
      const { data } = await blogFetch.get(`/ISAGA_Mensagem?skip=${skip}&take=${take}`);
      SetMessageSector(data)
      setTotalPages(Math.ceil(data.length / rowsPerPage))
    } catch (error) {
      console.error(error);
    }
  }

  const postMessageSector = async (data) => {
    try {
      const initialHour = data.mensagem_DataInicio.getHours();
      const endHour = data.mensagem_DataFim.getHours();

      data.mensagem_DataInicio.setHours((initialHour - 3))
      data.mensagem_DataFim.setHours((endHour - 3))

      await blogFetch.post('/ISAGA_Mensagem', data);

      getMessageSector();
      setShowModalAdd(false);
      toast.success(language[selectedCountry.name].Cadastro.mensagemSetor.notification.successAdd, {
        duration: 4000,
      });
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Cadastro.mensagemSetor.notification.errorAdd, {
        duration: 4000,
      });
    }
  }

  const putMessageSector = async (data) => {
    try {
      const initialHour = data.mensagem_DataInicio.getHours();
      const endHour = data.mensagem_DataFim.getHours();

      data.mensagem_DataInicio.setHours((initialHour - 3));
      data.mensagem_DataFim.setHours((endHour - 3));

      await blogFetch.put(`/ISAGA_Mensagem`, data);
      toast.success(language[selectedCountry.name].Cadastro.mensagemSetor.notification.successUpdate, {
        duration: 4000,
      });
      getMessageSector();
      setShowModalEdit(false);
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Cadastro.mensagemSetor.notification.errorUpdate, {
        duration: 4000,
      });
    }
  }

  const handleSelectedAddMessage = () => {
    setSelectedAddMessage(INITIAL_ADD_MESSAGE);
    setShowModalAdd(true);
  }
  const handleSelectedEditMessage = (data) => {
    setSelectedMessage({
      ...data,
      mensagem_DataInicio: dayjs(new Date(data.mensagem_DataInicio)).$d,
      mensagem_DataFim: dayjs(new Date(data.mensagem_DataFim)).$d
    });
    setShowModalEdit(true);
  }

  const handleAddMessage = ({ name, value }, type) => {
    switch (type) {
      case "ADD":
        setSelectedAddMessage({
          ...selectedAddMessage,
          isagA_Mensagem_Setores: [
            ...selectedAddMessage.isagA_Mensagem_Setores,
            { [name]: value }
          ]
        });
        break;
      case "REMOVE":
        setSelectedAddMessage({
          ...selectedAddMessage,
          isagA_Mensagem_Setores: selectedAddMessage.isagA_Mensagem_Setores
            .filter(item => item.msgSetor_Setor !== value)
        });
        break;
      case "ALL":
        setSelectedAddMessage({
          ...selectedAddMessage,
          isagA_Mensagem_Setores: value.map(item => ({
            msgSetor_Setor: item.stR_description
          }))
        });
        break;
      case "ALL_REMOVE":
        setSelectedAddMessage({
          ...selectedAddMessage,
          isagA_Mensagem_Setores: []
        });
        break;
      default:
        setSelectedAddMessage({
          ...selectedAddMessage,
          [name]: value
        });
        break;
    }
  }

  const handleEditMessage = ({ name, value }, type) => {
    switch (type) {
      case "ADD":
        setSelectedMessage({
          ...selectedMessage,
          isagA_Mensagem_Setores: [
            ...selectedMessage.isagA_Mensagem_Setores,
            { [name]: value }
          ]
        });
        break;
      case "REMOVE":
        setSelectedMessage({
          ...selectedMessage,
          isagA_Mensagem_Setores: selectedMessage.isagA_Mensagem_Setores
            .filter(item => item.msgSetor_Setor !== value)
        });
        break;
      case "ALL":
        setSelectedMessage({
          ...selectedMessage,
          isagA_Mensagem_Setores: value.map(item => ({
            msgSetor_Setor: item.stR_description
          }))
        });
        break;
      case "ALL_REMOVE":
        setSelectedMessage({
          ...selectedMessage,
          isagA_Mensagem_Setores: []
        });
        break;
      default:
        setSelectedMessage({
          ...selectedMessage,
          [name]: value
        });
        break;
    }
  }
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const offset = (page - 1) * itemsPerPage;
  const itemsToPaginate = messageSector;
  const paginatedData = itemsToPaginate.slice(offset, offset + itemsPerPage);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Cadastro.mensagemSetor.title}
            </h3>
          </div>
          <div>
            <Button
              className="btn add_button"
              variant="primary"
              onClick={() => handleSelectedAddMessage()}
            >
              {language[selectedCountry.name].Cadastro.mensagemSetor.btnAdicionar}
            </Button>
          </div>
        </div>

        <table className="table table-hover">
          <thead className="table-header">
            <tr className="table_row">
              <th>#</th>
              <th>{language[selectedCountry.name].Cadastro.mensagemSetor.tableHeader.mensagemTexto}</th>
              <th>{language[selectedCountry.name].Cadastro.mensagemSetor.tableHeader.mensagemDataInicio}</th>
              <th>{language[selectedCountry.name].Cadastro.mensagemSetor.tableHeader.mensagemDataFim}</th>
              <th>{language[selectedCountry.name].Cadastro.mensagemSetor.tableHeader.editar}</th>
            </tr>
          </thead>
          <tbody className="table_row">
            {paginatedData.map((item, i) => (
              <tr key={`messageSector-table-${i}`}>
                <td>{item.mensagem_Key}</td>
                <td>{item.mensagem_Texto}</td>
                <td>{DateTimeFmt(item.mensagem_DataInicio)}</td>
                <td>{DateTimeFmt(item.mensagem_DataFim)}</td>
                <td className="edit">
                  <center>
                    <ModeEditIcon
                      color="info"
                      onClick={() => handleSelectedEditMessage(item)}
                    />
                  </center>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          shape="rounded"
        /> */}

        <Pagination
          count={Math.ceil(itemsPerPage)}
          page={page}
          onChange={handlePageChange}
        />
      </div>
      <AddMensagemModal
        showModalAdd={showModalAdd}
        setShowModalAdd={setShowModalAdd}
        handleAddMessage={handleAddMessage}
        selectedAddMessage={selectedAddMessage}
        postMessageSector={postMessageSector}
        allSectors={allSectors ? allSectors?.filter(item => item?.stR_description) : []}
      />
      <EditMensagemModal
        showModalEdit={showModalEdit}
        setShowModalEdit={setShowModalEdit}
        selectedMessage={selectedMessage}
        handleEditMessage={handleEditMessage}
        putMessageSector={putMessageSector}
        allSectors={allSectors ? allSectors?.filter(item => item?.stR_description) : []}
      />
    </>
  )
}

